var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('markdown',{attrs:{"pagePath":"src/views/public/main/tou.md","slot-key":_vm.$parent.slotKey}},[_c('p',[_vm._v("Legal terms of use ....")])])}
var staticRenderFns = []

export { render, staticRenderFns }